<template>
    <v-app>
        <ToolBar/>
        <side-bar/>
        <views/>
    </v-app>
</template>

<script>

import SideBar from "./SideBar.vue" 
import Views from "./Views.vue" 
import ToolBar from "./ToolBar.vue" 

export default {
    components: {SideBar, Views, ToolBar},
    data () {
        return {
        }
    },
    

}
</script>
